import type { BaseEntityState, AuditFields } from '@crm/shared';

/**
 * EMAIL — Entità di engagement "email" del CRM, agganciabile a
 * Person/Business tramite Relationship polimorfica. Schema allineato a
 * rest-openapi.yaml (componente `Email`/`EmailInput`).
 *
 * Pattern speculare a Call ma senza `status`: il backend Email non
 * traccia esito (consegna/lettura non sono visibili lato CRM).
 *
 * SYNC CROSS-LAYER — modifiche vanno replicate in parallelo su:
 *   EmailDirection: modules/crm-util/.../EmailDirection.java,
 *                   emailMappers.ts (EMAIL_DIRECTIONS), locales/{it,en}.json
 */
export type EmailDirection = 'IN' | 'OUT';

// Array UI per Select (label = chiave i18n).
export const EMAIL_DIRECTIONS: { value: EmailDirection; label: string }[] = [
  { value: 'IN', label: 'email.directions.in' },
  { value: 'OUT', label: 'email.directions.out' },
];

export interface Email extends AuditFields {
  emailId: number;
  direction: EmailDirection;
  emailDate: string;
  description: string;
}

export interface EmailState extends BaseEntityState<Email> {
  filters: {
    direction?: EmailDirection;
  };
  totalCount: number;
}

export interface EmailCreatePayload {
  direction: EmailDirection;
  emailDate: string;
  description: string;
}

export interface EmailUpdatePayload extends Partial<EmailCreatePayload> {
  emailId: number;
}
